export default __webpack_public_path__ + "static/media/notification.ace6a703.svg";